import { TDSHelperObject } from "tds-ui/shared/utility";
export function mapperActiveBusinesses(data) {
    const businesses = data?.map((b) => TDSHelperObject.cloneObject(b));
    if (!businesses)
        return null;
    const result = [];
    businesses.forEach((b) => {
        const business = TDSHelperObject.cloneObject(b);
        const activeShops = business.shops?.filter((s) => s.isActive && !s.isLocked);
        if (activeShops && activeShops.length > 0) {
            business.shops = activeShops;
            result.push(business);
        }
    });
    return result;
}
//# sourceMappingURL=shop.js.map